/**
 * Created by jonas on 2020-11-04.
 */

import * as PIXI from "pixi.js";
export class MultiLayerBitmapFont extends PIXI.Container{
    get bitmapFonts():PIXI.BitmapText[] {
        return this._bitmapFonts;
    }

    private _bitmapFonts:PIXI.BitmapText[];
    public anchor:PIXI.ObservablePoint;
    private _text:string;

    constructor(text:string, layerStyles:any[]) {
        super();

        this.anchor = new PIXI.ObservablePoint(this.onAnchor,this, 0,0);
        this._bitmapFonts = [];
        for (let style of layerStyles){
            const bitmapText = new PIXI.BitmapText(text, style);
            this._bitmapFonts.push(bitmapText);
            this.addChild(bitmapText);
        }
    }

    private onAnchor() {
        for (let bitmapText of this._bitmapFonts){
            if (typeof bitmapText.anchor != "number"){
                bitmapText.anchor.set(this.anchor.x, this.anchor.y);
            }
        }
    }

    get text():string {
        return this._text;
    }

    set text(value:string) {
        this._text = value;
        for (let bitmapText of this._bitmapFonts){
            bitmapText.text = this._text;
        }
    }


    public setFontSize(size:number) {
        for (let bitmapText of this._bitmapFonts){
            bitmapText.fontSize = size;
        }
    }
}